import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementServiceReserveItemTicketSource`;


const ApiAmusementServiceReserveItemTicketSources = {
  getAll: (params) => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params });
  },
  getAllTicketsByBasketItemPersonIds: (params) => {
    const url = `${baseServiceUrl}/getAllTicketsByBasketItemPersonIds`;
    return ServiceApi.get(url, { params });
  },
  getAllAvailableTicketSources: (params) => {
    const url = `${baseServiceUrl}/getAllAvailableTicketSources`;
    return ServiceApi.get(url, { params });
  },
  downloadAmusementServiceReserveItemTicketSourceTemplate: () => {
    const url = `${baseServiceUrl}/downloadAmusementServiceReserveItemTicketSourceTemplate`;
    return ServiceApi.get(url, { responseType: "arraybuffer" });
  },
  getAllReserveItemTicketSourcesByExcel: (params) => {
    const url = `${baseServiceUrl}/getAllReserveItemTicketSourcesByExcel`;
    return ServiceApi.get(url, { responseType: "arraybuffer", params });
  },
  createAmusementServiceReserveItemTicketSourcesByExcel: (params) => {
    const url = `${baseServiceUrl}/createAmusementServiceReserveItemTicketSourcesByExcel`;
    return ServiceApi.post(url, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  updateAmusementServiceReserveItemTicketSourcesByExcel: (params) => {
    const url = `${baseServiceUrl}/updateAmusementServiceReserveItemTicketSourcesByExcel`;
    return ServiceApi.post(url, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  createAmusementServiceReserveItemTicketSourceInGrouping: (params) => {
    const url = `${baseServiceUrl}/createAmusementServiceReserveItemTicketSourceInGrouping`;
    return ServiceApi.post(url, params);
  },
  updateAmusementServiceReserveItemTicketSourceInGrouping: (params) => {
    const url = `${baseServiceUrl}/updateAmusementServiceReserveItemTicketSourceInGrouping`;
    return ServiceApi.put(url, params);
  },
  updateStatusAmusementServiceReserveItemTicketSource: (params) => {
    const url = `${baseServiceUrl}/updateStatusAmusementServiceReserveItemTicketSource`;
    return ServiceApi.post(url, params);
  },
  updateBasketItemPersonTicketSource: (params) => {
    const url = `${baseServiceUrl}/updateBasketItemPersonTicketSource`;
    return ServiceApi.post(url, params);
  },
  deleteAmusementServiceReserveItemTicketSource: (params) => {
    const url = `${baseServiceUrl}/deleteAmusementServiceReserveItemTicketSource`;
    return ServiceApi.delete(url, { data: params });
  }
};

export default ApiAmusementServiceReserveItemTicketSources;